import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { TableContainer, Paper,Table, TableBody, TableHead, Typography, ButtonBase} from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { StyledTableCell, StyledTableRow } from "../../components/styledtabelcell/StyledTabelCell";
import { connect, ConnectedProps } from 'react-redux';
import { getClusterEnvDetails, clearClusterEnvDetails } from './redux/actions';
import BackdropLoader from '../../components/loader/BackdropLoader';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { Dispatch } from "redux";
import { EnvironmentModel } from '../../models/Environment.model';

/* istanbul ignore next */
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  cardHeader: {
    padding: "0 !important",
  },
}));

interface Props extends PropsFromRedux {
  clusterId:number;
}

export function ClusterEnvironmentDetails(props:Props) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [t] = useTranslation();
  let history = useHistory();

  const handleExpandClick = () => {
    setExpanded(!expanded);
    setIsExpanded(true)
  };

  useEffect(() => {
    if(isExpanded){
      props.getClusterEnvDetails(props.clusterId) 
    }
    return () => {
      props.clearClusterEnvDetails()
    }   
  },[isExpanded])

  const goToEnv = (id:number) => {
    history.push(`/environment/${id}`)
  }

  return (
    <>
      <Card className="m-t-20" data-test="main-container" elevation={expanded ? 11 : 13}>
        <CardHeader
          data-test="card-header"
          // className={classes.cardHeader}
          // avatar={
          //     <IconButton
          //         className={clsx(classes.expand, {
          //             [classes.expandOpen]: expanded,
          //         })}
          //         onClick={handleExpandClick}
          //         aria-expanded={expanded}
          //         aria-label="show more"
          //     >
          //         <ExpandMoreIcon />
          //     </IconButton>
          // }
          title={
            <Typography variant="subtitle1" display="inline">
              {t('Cluster.ClusterEnvironmentDetails.header')}
              {/* {props?.clusterEnvData?.length > 0 && (
                <IconButton disabled="" data-test="icon-button">
                  <CheckCircleSharpIcon
                    fontSize="14"
                    style={{ color: "green" }}
                  />
                </IconButton>
              )} */}
            </Typography>
          }
          action={
            <IconButton
                className={clsx(classes.expand, {
                    [classes.expandOpen]: expanded,
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
            >
                <ExpandMoreIcon />
            </IconButton>
          }
        />
    
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
              <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table" data-test="table-data">
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell align="left"> {t('Cluster.ClusterEnvironmentDetails.environment')} </StyledTableCell>
                          <StyledTableCell align="left"> {t('Cluster.ClusterEnvironmentDetails.app')} </StyledTableCell>
                          <StyledTableCell align="left"> {t('Cluster.ClusterEnvironmentDetails.project')} </StyledTableCell>
                        </StyledTableRow>
                      </TableHead>
                      { props?.clusterEnvData?.length > 0 && props?.clusterEnvData?.map((env:EnvironmentModel,idx:number) => (
                          <TableBody key={idx}>
                                <StyledTableRow>
                                  <StyledTableCell>
                                    <ButtonBase
                                      onClick={() =>
                                        goToEnv(env?.id)
                                      }
                                      data-test="redirect-env-button"
                                    >
                                      <Typography color="primary" variant="h5">
                                        {env?.name}
                                      </Typography>
                                    </ButtonBase>
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                      {env?.application?.name}
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                      {env?.application?.project?.name}
                                  </StyledTableCell>
                                </StyledTableRow>
                          </TableBody>
                        ))
                      }
                    </Table>
                    {(!props.clusterEnvData ||  props?.clusterEnvData?.length <= 0 ) && (
                      <div className="cluster-info-message m-10" data-test="no-env">
                        <ErrorOutlineIcon fontSize="small" />
                        <Typography variant="caption" className="message">
                          {t('Cluster.ClusterEnvironmentDetails.noEnv')}
                        </Typography>
                      </div>
                    )}
              </TableContainer>
          </CardContent>
        </Collapse>
      </Card>
      {props.fetchingClusterEnvDetails && <BackdropLoader message={t('Cluster.ClusterEnvironmentDetails.fetching')} data-test="loader" />}
    </>
  );
}

/* istanbul ignore next */
const mapStateToProps = (state:any) => {
    return {
      clusterEnvData:  state.ClusterReducer.clusterEnvDetails,
      fetchingClusterEnvDetails: state.ClusterReducer.fetchingClusterEnvDetails
    }
}

/* istanbul ignore next */
const mapDispatchToProps = (dispatch:Dispatch) => {
    return {
        getClusterEnvDetails: (id:number) => dispatch(getClusterEnvDetails(id)),
        clearClusterEnvDetails: () => dispatch(clearClusterEnvDetails())
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ClusterEnvironmentDetails);